import type { OnboardingProgress } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Onboarding/Onboarding.Controller.ts

export class OnboardingAPI {
  static async getProgress(orgId: number, locationId: number, sourceId?: number): Promise<OnboardingProgress> {
    const source = sourceId != null ? `&sourceId=${sourceId}` : "";
    return APIService.Server.get<OnboardingProgress>(`/onboarding/org/${orgId}/progress?locationId=${locationId}${source}`);
  }

  static async ensureTicket(orgId: number, locationId: number, memberId: number, sourceId?: number): Promise<{ ticketNumber: number }> {
    return APIService.Server.post<{ ticketNumber: number }>(`/onboarding/org/${orgId}/ticket`, { locationId, memberId, sourceId });
  }
}
